/**
 * Shared back-navigation link — ChevronLeft + label, one consistent style.
 * (Back links were a mix of "← Back" text arrows and ChevronLeft icons with
 * different colors/hover treatments across detail pages.)
 */

import { Link } from "react-router-dom";

import { ChevronLeft } from "@/shared/components/icons";

export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1 text-sm text-text-muted hover:text-text transition"
    >
      <ChevronLeft size={16} strokeWidth={2} />
      {label}
    </Link>
  );
}
